/** Format seconds as "245h 30m" (mockup style). */
export const formatDurationHM = (seconds) => {
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  return `${hours.toLocaleString()}h ${minutes}m`;
};

/** Relative-ish last activity: "Today, 10:30 AM" or "May 20, 2025". */
export const formatLastActivity = (iso) => {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    const now = new Date();
    const sameDay = d.toDateString() === now.toDateString();
    if (sameDay) {
      return `Today, ${d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}`;
    }
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return '—';
  }
};

const PROJECT_ICON_TONES = [
  'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300',
  'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
  'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300',
  'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/40 dark:text-cyan-300',
];

export const projectColorIndex = (seed = '') => {
  const str = String(seed);
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash + str.charCodeAt(i) * (i + 1)) % PROJECT_ICON_TONES.length;
  }
  return hash;
};

export const projectIconTone = (seed = '') => PROJECT_ICON_TONES[projectColorIndex(seed)];

const PROJECT_DOT_COLORS = [
  'bg-primary-500',
  'bg-sky-500',
  'bg-emerald-500',
  'bg-amber-500',
  'bg-rose-500',
  'bg-cyan-500',
];

export const projectDotColor = (seed = '') => PROJECT_DOT_COLORS[projectColorIndex(seed)];

/** Map backend project health status → mockup lifecycle labels. */
export const projectDisplayStatus = (project) => {
  const raw = project?.project_status?.status || '';
  switch (raw) {
    case 'Complete':
      return 'Completed';
    case 'Planning':
      return 'Not Started';
    case 'On Time':
      return 'In Progress';
    case 'Delayed':
    case 'At Risk':
      return 'On Hold';
    default:
      return raw || 'Not Started';
  }
};

export const projectProgress = (project) => {
  const total = Number(project?.tasks_count) || 0;
  if (total <= 0) return 0;
  const done = Number(project?.completed_tasks_count) || 0;
  return Math.round((done / total) * 100);
};
